import React from 'react';
import './index.css';
import { HeaderSection } from './HeaderSection';
import { MainSection } from './MainSection';
function Typing() {
  return (
    <div>
      <HeaderSection />
      <MainSection />
    </div>
  );
}

export default Typing;
